<script>
import ContactForm from '../../components/contactForm.vue';
import GalleryInfo from '../../components/galleryInfo.vue';
import imagesZoom from '../../components/imagesZoom.vue';
import Loading from '../../components/loading.vue';

export default {
    name: "galleryDetail",
    data() {
        return {
            isLoading: false,
            detail: {
                high: [],
                goods: [],
            },
            list: [
                { height: 0, list: [] },
                { height: 0, list: [] },
                { height: 0, list: [] },
            ],
            listLoadedIndex: 0,
            isShowImgLoading: false,

            isShowImagesPanzoom: false,
            checkedIndex: null,
        };
    },
    computed: {},
    components: {
        ContactForm,
        GalleryInfo,
        imagesZoom,
        Loading
    },
    mounted() {
        this.getData();
    },
    destroyed() { 
        document.body.style.overflow = 'auto';
    },
    watch: {},
    methods: {
        InitList(index = 0) { 
            let obj = {...this.detail.high[index]};
            // 分析要添加到哪一列
            let heightArr = this.list.map(v => v.height);
            let min = Math.min(...heightArr);
            let listIndex = heightArr.findIndex(v => v == min);
            this.listLoadedIndex = listIndex;
            this.isShowImgLoading = true;
            // image
            let img = new Image();
            img.src = obj.image;
            img.onload = () => {
                // 宽，高，宽高比
                obj.width = img.width;
                obj.height = img.height;
                obj.ratio = img.height / img.width * 100;
                obj.realIndex = index;
                append(obj, index);
            }
            img.onerror = () => {
                obj.width = 100;
                obj.height = 100;
                obj.ratio = 100;
                obj.realIndex = index;
                append(obj, index);
            }
            const append = (obj, index) => {
                this.list[listIndex].list.push(obj);
                this.list[listIndex].height += obj.ratio;

                // 递归
                if (index < this.detail.high.length - 1) { 
                    this.InitList(++index);
                } else {
                    this.isShowImgLoading = false;
                }
            }
        },
        getData() {
            this.isLoading = true;
            this.$store.dispatch('getGalleryDetail', {
                id: this.$route.query.id
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) { 
                    this.detail = result.data;
                    this.InitList();
                }
            }).catch((err) => {
                this.isLoading = false;
            });
        },
        // 显示大图
        showImage(index) { 
            this.checkedIndex = index;
            document.body.style.overflow = 'hidden';
            this.isShowImagesPanzoom = true;
        },
        // 关闭图片弹窗
        closePopup() { 
            document.body.style.overflow = 'auto';
            this.isShowImagesPanzoom = false;
        }
    },
};
</script>

<template>
    <div class="gallery_detail">
        <div class="layout_body">
            <!-- banner -->
            <div class="banner">
                <div class="layout_bg" :style="`background-image: url(${detail.banner});`"></div>
            </div>
            <!--  -->
            <div class="layout_main">
                <div class="layout_content" v-if="isLoading">
                    <Loading/>
                </div>
                <div class="layout_content" v-else>
                    <p class="breadcrumb only_pc">
                        <router-link to="/gallery">A<sup>+</sup> Studio Gallery</router-link> / 
                        <router-link to="/gallery/exhibition" v-if="$route.path == '/gallery/exhibition/detail'">展览</router-link>
                        <router-link to="/gallery/activities" v-else-if="$route.path == '/gallery/activities/detail'">跨界活动</router-link>
                        <router-link to="/gallery/online" v-else-if="$route.path == '/gallery/online/detail'">线上展厅</router-link>
                        <router-link to="/gallery/online" v-else-if="$route.path == '/gallery/latestNews/detail'">最新消息</router-link>
                        / 时尚生活的色彩
                    </p>
                    <div class="detail flex">
                        <div class="content">
                            <div class="text">
                                <p class="name">{{ detail.name }}</p>
                                <p class="desc" v-html="$textToHtml(detail.desc)"></p>
                            </div>
                            <div class="btn_group flex">
                                <div class="btn layout_flex_center disabled" v-if="detail.is_end == 1">已结束</div>
                                <router-link class="btn layout_flex_center" v-else :to="`join?id=${$route.query.id}`">马上预约</router-link>
                                <div class="link layout_flex_center"><a href="">会员免费参观 —— 立即加入！</a></div>
                            </div>
                        </div>
                        <div class="content">
                            <div class="info">
                                <div class="item">
                                    <img :src="require('@/assets/images/icon_calendar.png')" alt="" class="icon calendar"/>
                                    <p class="title">展期：</p>
                                    <div class="desc">
                                        <p>{{ detail.start_time }} - {{ detail.end_time }}</p>
                                    </div>
                                </div>
                                <div class="item">
                                    <img :src="require('@/assets/images/icon_address.png')" alt="" class="icon address"/>
                                    <p class="title">地址：</p>
                                    <p class="desc" v-html="$textToHtml(detail.address)"></p>
                                </div>
                                <div class="item">
                                    <img :src="require('@/assets/images/icon_price.png')" alt="" class="icon price"/>
                                    <p class="title">票价：</p>
                                    <div class="desc">
                                        <p v-if="detail.price == '0.00'">免费</p>
                                        <p v-else>RMB {{ detail.price }}</p>
                                    </div>
                                </div>
                                <!-- <div class="item" v-if="detail.price != '0.00'">
                                    <img :src="require('@/assets/images/icon_price.png')" alt="" class="icon price"/>
                                    <p class="title">早鸟票：</p>
                                    <div class="desc">
                                        <p>RMB {{ detail.early_price }}</p>
                                    </div>
                                </div> -->
                            </div>
                            <p class="hint">会员和18岁以下免费</p>
                        </div>
                    </div>
                </div>
                <div class="layout_content" v-if="detail.high.length > 0">
                    <div class="top">
                        <div class="title">展会亮点</div>
                    </div>
                    <div class="images flex justify_between only_pc">
                        <div class="item_group flex flex_column" v-for="(item, index) in list" :key="index">
                            <div class="item" v-for="(_item, _index) in item.list" :key="_index" :data-index="_item.realIndex" @click="showImage(_item.realIndex)">
                                <div class="layout_bg cover" :style="`background-image: url(${_item.image});padding-bottom: ${_item.ratio}%;`"></div>
                                <div class="text">
                                    <p v-if="_item.name">{{ _item.name }}</p>
                                </div>
                            </div>
                            <Loading v-if="listLoadedIndex == index && isShowImgLoading"/>
                        </div>
                    </div>
                    <div class="images only_mobile">
                        <div class="item" v-for="(_item, _index) in detail.high" :key="'m' + _index" :data-index="_index" @click="showImage(_index)">
                            <!-- <div class="layout_bg bg" :style="`background-image: url(${_item.thumbnail ? _item.thumbnail : _item.image});padding-bottom: ${_item.ratio}%;`"></div> -->
                            <img :src="_item.thumbnail ? _item.thumbnail : _item.image" alt=""/>
                            <div class="text">
                                <p v-if="_item.name">名称：{{ _item.name }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="layout_content" v-if="detail.goods.length > 0">
                    <div class="top">
                        <div class="title">展览相关商品</div>
                    </div>
                    <div class="products flex flex_wrap justify_between">
                        <div class="item" v-for="(item, index) in detail.goods" :key="index">
                            <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                            <p class="name">{{ item.name }}</p>
                            <p class="link"><router-link :to="`/shop/detail?id=${item.id}`">立即购买</router-link></p>
                        </div>
                    </div>
                    <div class="flex justify_end products_btn">
                        <div class="btn layout_flex_center">成为会员</div>
                        <router-link class="btn layout_flex_center" to="/shop">更多商品</router-link>
                    </div>
                </div>
            </div>
        </div>
        <ContactForm from="画廊"/>
        <GalleryInfo/>
        <!-- 查看图片弹窗 -->
        <imagesZoom :show="isShowImagesPanzoom" @close="closePopup" :data="detail.high" :index="checkedIndex"/>
    </div>
</template>

<style scoped lang="scss">
.layout_content{
    .top{
        text-align: center;
        margin-bottom: .4rem;
        .title{
            font-size: .25rem;
            font-weight: bold;
        }
    }
    @media only screen and (max-width: 750px) {
        padding: 0;
        border-top: none;
        .top{
            .title{
                font-size: .32rem;
            }
        }
    }
}
.banner{
    height: 4.8rem;
    @media only screen and (max-width: 750px) {
        height: 6.3rem;
    }
}
.breadcrumb{
    font-size: .2rem;
    color: #666;
    margin-bottom: .3rem;
}
.detail{
    border: 1px solid #333;
    min-height: 4.6rem;
    @media only screen and (max-width: 750px) {
        flex-direction: column;
        border: none;
        margin-bottom: .3rem;
    }
    .content{
        padding: .3rem;
        border-right: 1px solid #333;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        &:last-child{
            border-right: none;
        }
        @media only screen and (max-width: 750px) {
            border: none;
            border-bottom: 1px solid #333;
            padding: .3rem 0;
        }
    }
    .text{
        width: 6.58rem;
        font-size: .18rem;
        line-height: 2;
        .name{
            font-size: .24rem;
            font-weight: bold;
            margin-bottom: .1rem;
        }
        @media only screen and (max-width: 750px) {
            width: 100%;
            font-size: .28rem;
            .name{
                font-size: .32rem;
            }
            .desc{
                margin-bottom: .2rem;
            }
        }
    }
    .btn_group{
        gap: 1rem;
        .btn{
            padding: 0 .15rem;
            height: .36rem;
            border: 1px solid #666;
            color: #666;
            font-size: .18rem;
            cursor: pointer;
            &.disabled{
                opacity: .6;
                pointer-events: none;
            }
        }
        .link{
            font-size: .16rem;
            a{
                border-bottom: 1px solid #666;
            }
        }
        @media only screen and (max-width: 750px) {
            flex-direction: column;
            gap: .3rem;
            .btn{
                width: auto;
                padding: 0 .2rem;
                height: .6rem;
                font-size: .26rem;
            }
            .link{
                font-size: .26rem;
            }
        }
    }
    .info{
        padding-top: .6rem;
        .item{
            margin-bottom: .2rem;
            display: flex;
            align-items: flex-start;
            line-height: 1.6;
            .icon{
                margin-right: .1rem;
                &.calendar{
                    width: .21rem;
                }
                &.price{
                    width: .24rem;
                }
                &.address{
                    width: .19rem;
                }
                @media only screen and (max-width: 750px) {
                    &.calendar{
                        width: .29rem;
                    }
                    &.price{
                        width: .32rem;
                    }
                    &.address{
                        width: .24rem;
                    }
                }
            }
            .title{
                font-size: .18rem;
                flex-shrink: 0;
            }
            .desc{
                font-size: .16rem;
            }
        }
        @media only screen and (max-width: 750px) {
            padding: 0;
            .item{
                .title{
                    font-size: .26rem;
                }
                .desc{
                    font-size: .26rem;
                }
            }
        }
    }
    .hint{
        font-size: .18rem;
        color: #666;
        @media only screen and (max-width: 750px) {
            font-size: .24rem;
        }
    }
}
.images{
    .item_group{
        width: 3.4rem;
        gap: .5rem;
    }
    .item{
        // border: 1px solid #999;
        cursor: pointer;
        .cover{
            height: 0;
        }
        .text{
            padding: .2rem;
            font-size: .18rem;
            text-align: center;
            // border-top: 1px solid #999;
        }
        @media only screen and (max-width: 750px) {
            margin-bottom: .3rem;
            img{
                width: 100%;
            }
            .text{
                font-size: .28rem;
            }
        }
    }
}
.products{
    gap: .5rem 0;
    .item{
        width: 3.4rem;
        .cover{
            height: 0;
            padding-bottom: 84.41%;
            // border: 1px solid #666;
            margin-bottom: .1rem;
        }
        .name{
            font-size: .2rem;
        }
        .link{
            font-size: .18rem;
            color: #666;
            a{
                border-bottom: 1px solid #666;
            }
        }
    }
}
.products_btn{
    gap: .3rem;
    margin-top: .5rem;
    .btn{
        padding: 0 .2rem;
        height: .4rem;
        border: 1px solid #666;
        color: #666;
        font-size: .18rem;
        cursor: pointer;
    }
}
</style>